
import Header from "@/atomic/atoms/Header";

import AccordionList from '@/atomic/atoms/AccordionList';
import { PropsView } from "./Models/faq";

export default function Faq(props: PropsView) {
	const { goBack, infos } = props;
	
	return (
		<div className="relative flex flex-1 flex-col w-full">
			<Header
				title="Perguntas frequentes"
				hasLeftButton
				goBack={goBack}
			/>
			<main className="z-10 p-2 w-full flex justify-center h-full text-black h-form">
				<article className="h-full flex flex-col justify-between w-[calc(480px)]">
					<div className={`w-full`}>
						<h2 className="text-black mt-6 font-bold text-2xl">Sobre o Free Flow</h2>
						<AccordionList items={infos || []} />
					</div>
				</article>
			</main>
		</div>
	);
}
